import { message } from 'ant-design-vue';
class Message {
    success(text){
        message.success(text);
    }
    info(text){
        message.info(text);
    }
    warning(text){
        message.warning(text);
    }
    error(text){
        message.error(text);
    }
}
export default new Message()
